export function initializeScrollToTop(selector: string) {
  const link = document.querySelector(selector)
  if (link) {
    link.addEventListener('click', (e: Event) => {
      e.preventDefault()
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: 0,
      })
    })
  }
}
